import PageHeader from '../../components/layout/PageHeader';
import AppointmentList from '../../components/scheduling/AppointmentList';

/**
 * Agent's appointments page. Defaults to "My calls" preset (assigned_to=me).
 * Agents can switch to "Orphans" to claim peers' calls left behind by
 * time-off, or to "All" for situational awareness.
 */
export default function AgentAppointments(): JSX.Element {
  return (
    <>
      <PageHeader
        title="Appointments"
        subtitle="Calls scheduled with you, plus orphans you can claim from peers on time-off."
      />
      <AppointmentList
        defaultFilters={{ assigned_to: 'me' }}
        viewerRole="agent"
      />
    </>
  );
}
